<article class="geodir-category-listing fl-wrap">
    <div class="geodir-category-img">
        <div class="geodir-js-favorite_btn" style="left: 10px; top: 10px;"> 
            <a *ngIf="isBrowser" [href]="qrCodeDownloadLink" download="qrcode" title="Download QR & Share profile">
                <qrcode [qrdata]='qrCodeString()' (qrCodeURL)="onChangeURL($event)" [width]="50" height="50" [errorCorrectionLevel]="'M'"></qrcode>
            </a>
        </div>
        <a [routerLink]="['/business-details', getHyphenatedString()]" class="geodir-category-img-wrap fl-wrap"
            title="{{business.businessName}}">
            <!--<img [src]="'../../assets/images/all/1.jpg'" alt="{{business.businessName}}">-->
            <img [src]="businessImageURL || '../../assets/images/all/1.jpg'" alt="{{business.businessName}}">
        </a>
        <div class="listing-avatar">
            <a href="javaScript:void(0);" title="{{business.firstName}}">
                <img [src]="profileImageURL || '../../assets/images/avatar/1.jpg'"
                    alt="{{business.firstName  | shorten: 10: '..'}}">
            </a>
            <span class="avatar-tooltip">Added By <strong> {{business.firstName}} </strong></span>
        </div>
        <div class="geodir_status_date color-bg"><i class="fal fa-clock"></i>{{business.businessCity}} </div>
        <div class="geodir-category-opt">
            <div class="listing-rating-count-wrap">
                <div class="review-score">{{feedAvg | number:'1.1-1'}}</div>
                <div class="listing-rating"><app-star-rating [rating]='feedAvg' [readonly]="true"></app-star-rating>
                </div>
                <br>
                <div class="reviews-count">{{feedTotal}} reviews</div>
            </div>
        </div>
    </div>
    <div class="geodir-category-content fl-wrap">
        <div class="geodir-category-content-title fl-wrap">
            <div class="geodir-category-content-title-item">
                <h3 class="title-sin_map">
                    <a [routerLink]="['/business-details', getHyphenatedString()]"
                        title="{{business.businessName}}">{{business.businessName | shorten: 27: '...'}}</a>
                </h3>
                <div class="geodir-category-location fl-wrap"><a href="javascript:void(0)" class="map-item">
                        <i class="fas fa-map-marker-alt"></i>{{business.detailAddress | shorten: 25: '-'}}
                        {{business.businessCity | shorten: 10}}</a>
                </div>
            </div>
        </div>
        <div class="geodir-category-text fl-wrap">
            <p class="small-text">{{business.aboutBusiness | shorten: 100: '...'}}</p>
            <div class="facilities-list fl-wrap hide">
                <div class="facilities-list-title">Facilities :{{business.categoryInfoId}} </div>
                <ul class="no-list-style">
                    <li class="tolt" data-microtip-position="top" data-tooltip="Free WiFi"><i class="fal fa-wifi"></i>
                    </li>
                    <li class="tolt" data-microtip-position="top" data-tooltip="Parking"><i class="fal fa-parking"></i>
                    </li>
                    <li class="tolt" data-microtip-position="top" data-tooltip="Non-smoking Rooms"><i
                            class="fal fa-smoking-ban"></i></li>
                    <li class="tolt" data-microtip-position="top" data-tooltip="Pets Friendly"><i
                            class="fal fa-dog-leashed"></i></li>
                </ul>
            </div>
        </div>
        <div class="geodir-category-footer fl-wrap">
            <a href="javascript:void(0);" class="listing-item-category-wrap">
                <div class="listing-item-category purp-bg"><i class="fal fa-tree-alt"></i></div>
                <span> {{business.categoryName | shorten: 10: '...'}} </span>
            </a>
           
            <div class="geodir-opt-list">
                <ul class="no-list-style">
                    <li><a href="javascript:void(0);" (click)="clickEvent()"><i class="fal fa-phone"></i><span class="geodir-opt-tooltip">Call To</span></a></li>
                    <li>
                         <a href="javascript:void(0);" (click)="enquiryModalEvent([business.userInfoId])">
                            <i class="fal fa-envelope"></i><span class="geodir-opt-tooltip">Send Inquiry</span>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);" (click)="mapModalEvent(this.business.googleLatitude,this.business.googleLongitude, this.business.businessName)">
                            <i class="fal fa-map-marker-alt"></i>
                            <span class="geodir-opt-tooltip">On the map</span> 
                        </a> 
                    <li><a [routerLink]="['/business-details', getHyphenatedString()]" title="View business details"><i class="fal fa-arrow-alt-right"></i><span class="geodir-opt-tooltip">Details </span> </a>
                    </li>
                    <!-- 
                      <li>
                          <div class="dynamic-gal gdop-list-link" data-dynamicPath="[{'src': '../../assets/images/all/1.jpg'},{'src': '../../assets/images/all/1.jpg'}, {'src': '../../assets/images/all/1.jpg'}]"><i class="fal fa-search-plus"></i><span class="geodir-opt-tooltip">Gallery</span></div>
                      </li> 
                      -->
                </ul>
            </div>
          
            <!-- phone wrapper -->
            <div class="geodir-category_contacts" [ngClass]="addRemoveClass ? 'visgdcc' : ''">
                <div class="close_gcc" (click)="clickEvent()" [ngClass]="addRemoveClass ? 'visgdcc' : ''"><i
                        class="fal fa-times-circle"></i></div>
                <ul class="no-list-style">
                    <li><span><i class="fal fa-phone"></i> Call : </span><a href="tel:{{business.phoneNumber | hide:'phone':5}}">+91
                            {{business.phoneNumber | hide:'phone':5}}</a></li>
                    <li><span style="margin-right: 3px;"><i class="far fa-globe"></i> </span><a
                            href="{{business.businessWebsite}}"> {{business.businessWebsite}}</a></li>
                </ul>
            </div>
        </div>
    </div>
</article>